import React from "react";
import { Link } from "react-router-dom";
import { SCORE_IMPACT_FACTORS } from "../../constants/mentalPatternsHub.js";

export const SuggestedReflectionToday = ({ prompt }) => (
  <section className="mp-suggested" aria-labelledby="mp-suggested-title">
    <h2 id="mp-suggested-title" className="mp-section-title">
      Suggested reflection today
    </h2>
    <p className="mp-suggested__prompt">{prompt}</p>
    <Link to="/" className="mp-suggested__cta primary-button">
      Start guided reflection
    </Link>
  </section>
);

export const ScoreImpactFactors = () => (
  <section className="mp-score-factors" aria-labelledby="mp-score-factors-title">
    <h2 id="mp-score-factors-title" className="mp-section-title">
      What impacts your score
    </h2>
    <ul className="mp-score-factors__grid">
      {SCORE_IMPACT_FACTORS.map((item) => (
        <li key={item} className="mp-score-factors__pill">
          {item}
        </li>
      ))}
    </ul>
  </section>
);

export const MentalLoopsDetected = ({ loops }) => {
  if (!loops?.length) return null;

  return (
    <section className="mp-loops" aria-labelledby="mp-loops-title">
      <h2 id="mp-loops-title" className="mp-section-title">
        Repeating mental loops detected
      </h2>
      <ul className="mp-loops__list">
        {loops.map((loop) => (
          <li key={loop.id} className="mp-loops__item">
            <p className="mp-loops__name">{loop.title}</p>
            {loop.description ? <p className="mp-loops__desc">{loop.description}</p> : null}
            {!loop.placeholder && loop.hits > 0 ? (
              <p className="mp-loops__note">
                Seen in {loop.hits} reflection{loop.hits !== 1 ? "s" : ""}
                {loop.source === "cbt" ? " (confirmed thinking pattern)" : ""}.
              </p>
            ) : null}
            {loop.placeholder ? (
              <p className="mp-loops__note">Pattern may appear as you add more reflections.</p>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
};
